// Mirrors the BE `_canonical_uuid` contract: canonical lowercase-hyphenated
// spelling, any UUID version. Braces, urn: prefixes, unhyphenated, and
// mixed-case spellings are rejected, not coerced — the id is a client-chosen
// upsert key the BE stores and compares byte-for-byte.
const CANONICAL_UUID_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;

export const isValidDesktopInstanceId = (instanceId: string): boolean =>
  CANONICAL_UUID_REGEX.test(instanceId);

/**
 * Turn-body field naming the desktop that submitted a target-mode turn. Takes
 * the native installation id targets register with. Empty when the id is
 * missing or not a valid UUID, so the backend never rejects the request.
 */
export const initiatingDesktopInstanceFields = (
  instanceId: string | null
): { initiating_desktop_instance_id?: string } =>
  instanceId && isValidDesktopInstanceId(instanceId)
    ? { initiating_desktop_instance_id: instanceId }
    : {};
